/** Убираем из текста для пользователя URL, упоминания доменов разработчика и служебные префиксы HTTP-кода. */
export function sanitizeUserFacingMessage(raw: string): string {
  if (!raw?.trim()) {
    return 'Что-то пошло не так. Попробуйте ещё раз.'
  }
  let s = raw
    .replace(/https?:\/\/[^\s]+/gi, '')
    .replace(/\b[\w.-]*lushpanov\.[a-z]{2,}\b/gi, '')
    .replace(/\[[0-9]+\]\s*/g, '')
  s = s.replace(/\s{2,}/g, ' ').trim()
  if (s.length < 2) {
    return 'Что-то пошло не так. Попробуйте ещё раз.'
  }
  return s
}
